(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["365-project-overview"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.project365').forEach(function(section) {
  var phrase = section.querySelector('[data-project365-pen-phrase]');
  var source = section.querySelector('.project365__pen-sayings');
  if (!phrase || !source) return;

  var sayings = Array.from(source.querySelectorAll('span')).map(function(item) {
    return item.textContent.trim();
  }).filter(Boolean);

  if (sayings.length < 2) return;

  var index = 0;

  window.setInterval(function() {
    phrase.style.opacity = '0';

    window.setTimeout(function() {
      index = (index + 1) % sayings.length;
      phrase.textContent = sayings[index];
      phrase.style.opacity = '1';
    }, 180);
  }, 3200);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
